const BASKET_PAYMENT_MODES = {
  SINGLE_PAYMENT: 'SINGLE_PAYMENT',
  SUBSCRIPTION_PAYMENT: 'SUBSCRIPTION_PAYMENT',
} as const;

export default BASKET_PAYMENT_MODES;
